import { useCallback, useEffect, useRef, useState } from 'react';

import { devLog } from './logging.js';

/** @internal */
export const useCopyToClipboard = (
  value: string,
): [() => void, boolean, (value: boolean) => void] => {
  const copyableString = useRef(value);
  const [copied, setCopied] = useState(false);
  const copyToClipboard = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(copyableString.current);
      setCopied(true);
    } catch {
      devLog(
        'Clipboard access was blocked (restricted iframe or strict CSP). Nothing was copied.',
      );
    }
  }, [copyableString]);

  useEffect(() => {
    copyableString.current = value;
    setCopied(false);
  }, [value]);

  return [copyToClipboard, copied, setCopied];
};
